import React, { useEffect, useId, useState } from 'react'
import classes from './paperMatrixQues.module.css'
import { Col, Row } from 'react-bootstrap'
import userService from '../../../app/services/user.service'
import Card from '../../../UI/Card/Card'
import CheckMark from '../../../UI/CheckMark/CheckMark'
import Select from '../../../UI/Select/Select'
import { isEmpty } from '../../../utils/custom_funtions'
import { ThreeDots } from 'react-loader-spinner'
import { uid as ruid } from 'react-uid'

const PaperMatrixQues = ({
  qNo,
  qid,
  pid,
  type,
  type_id,
  sectionName,
  selectedTopic,
  selectedSubTopic,
  selectedToughness,
  transferedTopic,
  subTopicHandler,
  toughnessHandler,
  listTopic,
  listSubTopic,
  listToughness,
  copyHandler,
  validate,
  updateMatrix,
  matrixLength,
  matrixByUidData,
  sec_id,
  prevSec_id,
  color_code,
  nextSec_id,
  showEl
}) => {
  const uniId = useId()
  const [subTopicListByTopic, setSubTopicListByTopic] = useState([]);
  const [quesAvailability, setQuesAvailability] = useState({"used":"","unused":""});
  const [loading, setLoading] = useState({loader1:false,loader2:false});

  console.log(showEl);
  // const [quesAvailability, setQuesAvailability] = useState(null);
  useEffect(()=>{
    if(updateMatrix){
      setSubTopicListByTopic(() => {
        return listSubTopic.filter(x=>x.topic_id == selectedTopic)
      })
    }
  },[updateMatrix])
  useEffect(()=>{
    setSubTopicListByTopic(() => {
      return listSubTopic.filter(x=>x.topic_id == selectedTopic)
    })
  },[copyHandler])
  useEffect(() => {
    if(type_id !== (5 || 9 || 10 || 11 || 12 || 13 ||14 || 15)) {
      if (selectedTopic || selectedSubTopic || selectedToughness){
        const body = {
          "pid":pid,
          "topic_id":selectedTopic,
          "sub_topic_id":selectedSubTopic,
          "toughness_id":selectedToughness,
          "type_id":type_id
        }
        setLoading({loader1:true,loader2:true})
        userService.getUsedQues(body)
        .then(res => {
          setLoading(prev => {
            return {
              ...prev,
              loader1:false
            }
          })
          setQuesAvailability(prev => {
            return {
              ...prev,
              "used":res.data.data[0]?.used
            }
          })
        })
        .catch(err =>{
          console.log(err);
          setLoading(prev => {
            return {
              ...prev,
              loader1:false
            }
          })
        })
        userService.getUnusedQues(body)
        .then(res => {
          setLoading(prev => {
            return {
              ...prev,
              loader2:false
            }
          })
          setQuesAvailability(prev => {
            return {
              ...prev,
              "unused":res.data.data[0]?.not_used
            }
          })
        })
        .catch(err =>{
          console.log(err);
          setLoading(prev => {
            return {
              ...prev,
              loader2:false
            }
          })
        })
      }
    } else {
      if(!isEmpty(selectedTopic) && !isEmpty(selectedToughness)){
        const body = {
          "pid":pid,
          "topic_id":selectedTopic,
          // "sub_topic_id":selectedSubTopic,
          "toughness_id":selectedToughness,
          "type_id":type_id
        }
        setLoading({loader1:true,loader2:true})
        userService.getUsedQues(body)
        .then(res => {
          console.log("used",res.data.data[0].used);
          setLoading(prev => {
            return {
              ...prev,
              loader1:false
            }
          })
          setQuesAvailability(prev => {
            return {
              ...prev,
              "used":res.data.data[0].used
            }
          })
        })
        .catch(err =>{
          console.log(err);
          setLoading(prev => {
            return {
              ...prev,
              loader1:false
            }
          })
        })
        userService.getUnusedQues(body)
        .then(res => {
          console.log("unused",res.data.data[0].not_used);
          setLoading(prev => {
            return {
              ...prev,
              loader2:false
            }
          })
          setQuesAvailability(prev => {
            return {
              ...prev,
              "unused":res.data.data[0].not_used
            }
          })
        })
        .catch(err =>{
          console.log(err);
          setLoading(prev => {
            return {
              ...prev,
              loader2:false
            }
          })
        })
      }
    } 
    
  },[selectedTopic,selectedSubTopic,selectedToughness])
  const selectHandler1 = (e,condition = false) => {
    transferedTopic(e.target.value, condition);
    setSubTopicListByTopic(() => {
      return listSubTopic.filter(x=>x.topic_id == e.target.value)
    })
    // userService
    //   .getSubTopicByTid(e.target.value)
    //   .then((data) => {
    //     console.log("setListSubTopic",data.data.data);
    //     setListSubTopic(data.data.data);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     setListSubTopic([]);
    //     if(err.response.data.info === 500){
    //        alert("No Sub Topic found for this Topic")
    //     } 
    //   });
  };
  //  style={{marginTop: qNo !==1 ? (sec_id !== prevSec_id ? "2.5rem" :0) : 0, backgroud:color_code}}


  console.log("Matrix Data by UID ",matrixByUidData);
  return (
    <>
    {type_id == (5 || 9 || 10)  ? 
     (showEl ? 
     <>
     {(qNo !==1 && sec_id !== prevSec_id) && <hr/> }
     <Card className={(!isEmpty(matrixByUidData) && qid===null) ? classes.redBorder : (validate ? classes.greenBorder : "")} 
      style={{backgroundColor : `${color_code}2e`}}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        
        <h4>
        {(!isEmpty(matrixByUidData) && qid===null) ? <i className='bx bx-x' style={{color:"red",fontSize:"2rem",fontWeight:600,lineHeight:1}}></i> : (validate && <CheckMark />)}
          {/* {validate && <CheckMark />}  */}
          Q{qNo}-{qNo+1} . {type}{" "}
          <span className="h6">({sectionName})</span>{" "}
        </h4>
        {/* {qNo !== matrixLength && (
          <i
            className="bx bx-copy h4"
            style={{ cursor: "pointer" }}
            onClick={copyHandler}
          ></i>
        )} */}
      </div>
      <Row>
        <Col lg={4} md={12} sm={12}>
          <Select onChange={e => selectHandler1(e,true)} value={selectedTopic} >
            <option value="" selected disabled>
              Select Topic
            </option>
            {listTopic.map((list) => {
              return (
                <option key={ruid(list)+uniId} value={list.topic_id}>
                  {list.topic_name}
                </option>
              );
            })}
          </Select>
        </Col>
        {(type_id !== (5 || 9 || 10 || 11 || 12 || 13 ||14 || 15)) && (
          <Col lg={4} md={12} sm={12}>
          <Select value={selectedSubTopic} onChange={subTopicHandler} >
            <option value="" selected disabled>
              {subTopicListByTopic.length !== 0 && selectedTopic > 0
                ? "Select Subtopic"
                : selectedTopic > 0
                ? "No subtopic Found"
                : "Select Subtopic"}
            </option>
            {subTopicListByTopic.map((list) => {
              return (
                <option key={list.sub_topic_id} value={list.sub_topic_id}>
                  {list.sub_topic_name}
                </option>
              );
            })}
          </Select>
        </Col>
        )}
        
        <Col lg={4} md={12} sm={12}>
          <Select
            value={selectedToughness}
            onChange={e => toughnessHandler(e,true)}
            
          >
            <option value="" selected disabled>
              Select Toughness
            </option>
            {listToughness.map((list) => {
              return (
                <option key={list.toughness_id} value={list.toughness_id}>
                  {list.toughness}
                </option>
              );
            })}
          </Select>
        </Col>
      </Row>
      <div className="text-center">
        <small>
          (Used Questions :{" "}
          <b>
            {isEmpty(quesAvailability.used) ? (
              !loading.loader1 ? (
                "NA"
              ) : (
                <ThreeDots
                  height="25"
                  width="25"
                  radius="9"
                  color="#950202"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{ display: "inline-block" }}
                  wrapperClassName=""
                  visible={true}
                />
              )
            ) : (
              quesAvailability.used
            )}
          </b>
          {"   "}
          Available Questions :{" "}
          <b>
            {isEmpty(quesAvailability.unused) ? (
              !loading.loader2 ? (
                "NA"
              ) : (
                <ThreeDots
                  height="25"
                  width="25"
                  radius="9"
                  color="#950202"
                  ariaLabel="three-dots-loading"
                  wrapperClassName=""
                  visible={true}
                  wrapperStyle={{ display: "inline-block" }}
                />
              )
            ) : (
              quesAvailability.unused
            )}
          </b>
          )
        </small>
      </div>
    </Card>
    
    
     </>
      
     : "")
     : 
     <>
     {(qNo !==1 && sec_id !== prevSec_id) && <hr/> }
    <Card className={(!isEmpty(matrixByUidData) && qid===null) ? classes.redBorder : (validate ? classes.greenBorder : "")} 
    style={{backgroundColor : `${color_code}14`}}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        
        <h4>
        {(!isEmpty(matrixByUidData) && qid===null) ? <i className='bx bx-x' style={{color:"red",fontSize:"2rem",fontWeight:600,lineHeight:1}}></i> : (validate && <CheckMark />)}
          {/* {validate && <CheckMark />}  */}
          Q{qNo}. {type}{" "}
          <span className="h6">({sectionName})</span>{" "}
        </h4>
        {(qNo !== matrixLength &&sec_id === nextSec_id) &&  (
           
          <i
            className="bx bx-copy h4"
            style={{ cursor: "pointer" }}
            onClick={copyHandler}
          ></i>
        )}
      </div>
      <Row>
        <Col lg={4} md={12} sm={12}>
          <Select onChange={selectHandler1} value={selectedTopic}>
            <option value="" selected disabled>
              Select Topic
            </option>
            {listTopic.map((list) => {
              return (
                <option key={list.topic_id} value={list.topic_id}>
                  {list.topic_name}
                </option>
              );
            })}
          </Select>
        </Col>
        {(type_id !== (5 || 9 || 10 || 11 || 12 || 13 ||14 || 15)) && (
          <Col lg={4} md={12} sm={12}>
          <Select value={selectedSubTopic} onChange={subTopicHandler} >
            <option value="" selected disabled>
              {subTopicListByTopic.length !== 0 && selectedTopic > 0
                ? "Select Subtopic"
                : selectedTopic > 0
                ? "No subtopic Found"
                : "Select Subtopic"}
            </option>
            {subTopicListByTopic.map((list) => {
              return (
                <option key={list.sub_topic_id} value={list.sub_topic_id}>
                  {list.sub_topic_name}
                </option>
              );
            })}
          </Select>
        </Col>
        )}
        
        <Col lg={4} md={12} sm={12}>
          <Select
            value={selectedToughness}
            onChange={toughnessHandler}
          >
            <option value="" selected disabled>
              Select Toughness
            </option>
            {listToughness.map((list) => {
              return (
                <option key={list.toughness_id} value={list.toughness_id}>
                  {list.toughness}
                </option>
              );
            })}
          </Select>
        </Col>
      </Row>
      <div className="text-center">
        <small>
          (Used Questions :{" "}
          <b>
            {isEmpty(quesAvailability.used) ? (
              !loading.loader1 ? (
                "NA"
              ) : (
                <ThreeDots
                  height="25"
                  width="25"
                  radius="9"
                  color="#950202"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{ display: "inline-block" }}
                  wrapperClassName=""
                  visible={true}
                />
              )
            ) : (
              quesAvailability.used
            )}
          </b>
          {"   "}
          Available Questions :{" "}
          <b>
            {isEmpty(quesAvailability.unused) ? (
              !loading.loader2 ? (
                "NA"
              ) : (
                <ThreeDots
                  height="25"
                  width="25"
                  radius="9"
                  color="#950202"
                  ariaLabel="three-dots-loading"
                  wrapperClassName=""
                  visible={true}
                  wrapperStyle={{ display: "inline-block" }}
                />
              )
            ) : (
              quesAvailability.unused
            )}
          </b>
          )
        </small>
      </div>
    </Card>
    </>
  }
    </>
  );
};

export default PaperMatrixQues

